<template>
  <div class="col-span-12">
    <div class="mb-4">
      <p class="font-medium sm:text-lg">
        {{ (field && field.display) || label }}
      </p>
      <p v-if="field">{{ field.instructions }}</p>
    </div>

    <Field
      v-slot="{ handleChange, value }"
      :rules="rulesAsString"
      :name="name || handle || field.handle"
      :label="label || field.label || field.display"
    >
      <div
        class="flex items-start"
        :class="[
          multiple
            ? 'flex-col-reverse space-y-2'
            : 'flex-col sm:flex-row sm:items-center',
        ]"
      >
        <input
          :id="`${idPrefix}actual-btn`"
          type="file"
          hidden
          :multiple="multiple"
          @change="handleChange"
        />
        <!-- our custom upload button -->
        <label
          :for="`${idPrefix}actual-btn`"
          class="cursor-pointer bg-blue-100/20 px-5 py-3 font-medium text-blue-800 transition-colors hover:bg-blue-100"
          :class="{ 'mt-6': multiple }"
        >
          {{ btnLabel || $t('upload_file') }}
        </label>

        <!-- name of file chosen -->
        <span
          v-if="!multiple"
          id="file-chosen"
          class="mt-4 break-all sm:ml-5 sm:mt-0"
        >
          {{ value?.name || initialFileName || $t('no_file_selected') }}
        </span>
        <span
          v-for="(file, index) in value"
          v-else
          id="file-chosen"
          :key="index"
          class="mt-2 flex items-center break-all font-medium"
        >
          {{ file.name }}
        </span>
      </div>
    </Field>

    <Transition name="fade">
      <p v-if="error" class="pt-3 text-sm leading-5 text-red">
        {{ error }}
      </p>
    </Transition>
  </div>
</template>

<script setup>
import { Field } from 'vee-validate'

const props = defineProps({
  field: {
    type: Object,
    default: null,
  },

  label: {
    type: String,
    default: '',
  },

  handle: {
    type: String,
    default: '',
  },

  name: {
    type: String,
    default: '',
  },

  btnLabel: {
    type: String,
    default: null,
  },

  rules: {
    type: [Array, String],
    default: '',
  },

  error: {
    type: String,
    default: null,
  },

  multiple: {
    type: Boolean,
    default: null,
  },
  idPrefix: {
    type: String,
    default: '',
  },
  initialFileName: {
    type: String,
    default: '',
  },
})

const rulesAsString = computed(() => {
  if (Array.isArray(props.rules)) {
    return props.rules.join('|')
  }
  return props.rules
})
</script>
